"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";

export interface CodeTab {
  label: string;
  language: string;
  code: string;
}

interface Props {
  tabs: CodeTab[];
}

export function CodeTabs({ tabs }: Props) {
  const [active, setActive] = useState(0);
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(tabs[active].code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore
    }
  }

  return (
    <div className="my-4 rounded-xl border border-stone-200 bg-stone-950 overflow-hidden">
      <div className="flex items-center justify-between bg-stone-900 border-b border-stone-800 pl-2 pr-3">
        <div className="flex">
          {tabs.map((t, i) => (
            <button
              key={t.label}
              onClick={() => setActive(i)}
              className={[
                "px-3 py-2 text-[11px] font-mono transition-colors border-b-2",
                active === i
                  ? "text-violet-300 border-violet-400"
                  : "text-stone-400 border-transparent hover:text-stone-200",
              ].join(" ")}
            >
              {t.label}
            </button>
          ))}
        </div>
        <button
          onClick={handleCopy}
          className="text-stone-400 hover:text-stone-200 transition-colors text-[11px] inline-flex items-center gap-1.5"
        >
          {copied ? (
            <>
              <Check className="w-3 h-3" /> Copiado
            </>
          ) : (
            <>
              <Copy className="w-3 h-3" /> Copiar
            </>
          )}
        </button>
      </div>
      <pre className="overflow-x-auto p-4 text-xs sm:text-[13px] leading-relaxed text-stone-200 font-mono whitespace-pre">
        {tabs[active].code}
      </pre>
    </div>
  );
}
